export default "__VITE_ASSET__BIMRKelz__"